import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { auth } from "../firebase-config";
import backgroundImage from "../images/CMCP_background.png";
import SideMenu from "./SideMenu";
import Header from "./Header";
import MobileNav from "./MobileNav";
import scrollToTop from "../utils/scrollToTop";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faHome,
  faUserMd,
  faChartLine,
  faQuestionCircle,
  faNewspaper,
  faBuilding,
  faShieldAlt,
  faMicroscope,
  faClipboardList,
  faUsers,
  faEnvelope,
  faSignInAlt,
  faSignOutAlt,
  faBars,
  faTimes,
  faTags,
  faDollarSign,
  faChartBar,
} from "@fortawesome/free-solid-svg-icons";
import "./SharedLayout.css";

const SharedLayout = ({ user, onLoginClick, children }) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  // Add effect to scroll to top when the route changes
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  const toggleMenu = () => {
    console.log("Toggle menu called, current state:", isMenuOpen);
    setIsMenuOpen(!isMenuOpen);
  };

  const handleNavigation = (path) => {
    navigate(path);
    scrollToTop();
  };

  return (
    <div className="shared-layout">
      {location.pathname !== "/questionnaire" && location.pathname !== "/epitome" && <Header
        onMenuClick={toggleMenu}
        user={user}
        onLoginClick={onLoginClick}
      />}
      {location.pathname !== "/questionnaire" && location.pathname !== "/epitome" && (
        <SideMenu user={user} onLoginClick={onLoginClick} />
      )}
      <div className="content">{children}</div>

      {/* Mobile Navigation */}
      {location.pathname !== "/questionnaire" && location.pathname !== "/epitome" && (
        <MobileNav 
          isOpen={isMenuOpen}
          onClose={() => setIsMenuOpen(false)}
          onLoginClick={onLoginClick}
          user={user}
          onNavigate={handleNavigation}
        />
      )}
    </div>
  );
};

export default SharedLayout;
